import isServerSide from './isServerSide'

export default function AddCssSelector(selector, property) {
  if (isServerSide()) return
  const style: any = document.createElement('style')
  const css = `${selector} {${property};}`
  if (style.styleSheet) {
    style.styleSheet.cssText = css
  } else {
    style.appendChild(document.createTextNode(css))
  }
  const headElement = document.head
  headElement.appendChild(style)
}
